var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9667 20.1666L12.1917 14.1166C11.7333 14.5007 11.2063 14.8048 10.6104 15.0289C10.0146 15.2529 9.38056 15.365 8.70833 15.365C7.04306 15.365 5.63368 14.7608 4.48021 13.5524C3.32674 12.344 2.75 10.8675 2.75 9.12292C2.75 7.37835 3.32674 5.90186 4.48021 4.69346C5.63368 3.48506 7.04306 2.88086 8.70833 2.88086C10.3736 2.88086 11.783 3.48506 12.9365 4.69346C14.0899 5.90186 14.6667 7.37835 14.6667 9.12292C14.6667 9.82716 14.5597 10.4914 14.3458 11.1156C14.1319 11.7398 13.8417 12.292 13.475 12.7721L19.25 18.8221L17.9667 20.1666ZM8.70833 13.4444C9.85417 13.4444 10.8281 13.0242 11.6302 12.1839C12.4323 11.3437 12.8333 10.3233 12.8333 9.12292C12.8333 7.92253 12.4323 6.90219 11.6302 6.06191C10.8281 5.22163 9.85417 4.80149 8.70833 4.80149C7.5625 4.80149 6.58854 5.22163 5.78646 6.06191C4.98438 6.90219 4.58333 7.92253 4.58333 9.12292C4.58333 10.3233 4.98438 11.3437 5.78646 12.1839C6.58854 13.0242 7.5625 13.4444 8.70833 13.4444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f5aeab1c528b5d918b427d3c25ab8cd2.svg";
export { ForwardRef as ReactComponent };